export default "__VITE_ASSET__32e9e908__"